import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.title',
    defaultMessage: 'Create Announcement',
  },
  fieldTitle: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.fieldTitle',
    defaultMessage: 'Title',
  },
  fieldBody: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.fieldBody',
    defaultMessage: 'Body',
  },
  fieldUserType: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.fieldUserType',
    defaultMessage: 'User type',
  },
  fieldPartner: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.fieldPartner',
    defaultMessage: 'Partner',
  },
  fieldTags: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.fieldTags',
    defaultMessage: 'Tags',
  },
  partnerAll: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.partnerAll',
    defaultMessage: 'All partners',
  },
  userTypeCustomer: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.userTypeCustomer',
    defaultMessage: 'Customer',
  },
  userTypeSupplier: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.userTypeSupplier',
    defaultMessage: 'Supplier',
  },
  userTypeCoordinator: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.userTypeCoordinator',
    defaultMessage: 'Coordinator',
  },
  cancel: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.cancel',
    defaultMessage: 'Cancel',
  },
  create: {
    id: 'containers.AnnouncementsPage.AnnouncementCreateModal.create',
    defaultMessage: 'Create',
  },
})
